import { useMutation } from '@tanstack/react-query';
import { DeleteCounterpartyResponse } from '@spilca/accounting_ts/v1/auth_common/dtos_pb';
import { TGRPCPromiseReject } from '@monorepo/grpc';
import { REQUEST_TYPES, useGetRequest } from '@monorepo/requests';

const useDeleteClient = () => {
  const mutator = useGetRequest(REQUEST_TYPES.DELETE_CLIENT);

  return useMutation<
    DeleteCounterpartyResponse | null,
    TGRPCPromiseReject,
    number
  >({
    mutationFn: mutator,
    retry: false
  });
};

export default useDeleteClient;
